import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationStateService } from './core/services/authentication-state.service';
import { LanguageService } from '@app/services/language/language.service';
import { ThemeService } from '@app/services/theme/theme.service';
import { Store } from '@ngrx/store';
import { JwtService } from '@app/core/services/jwt.service';
import { selectCoreState,selectMeState } from './core/store/core.selectors';
import * as CoreActions from '@app/core/store/core.action';
import { filter, tap } from 'rxjs';
import * as ProductActions from '@app/modules/products/store/actions/products.actions';
import { skipWhile, switchMap, take } from 'rxjs/operators';
import { BnNgIdleService } from 'bn-ng-idle';
import { MatDialog } from '@angular/material/dialog';
import { SessionExpiredComponent } from './shared/components/session-expired/session-expired.component';
import LogRocket from 'logrocket';
import { environment } from '@app/../environments/environment';
import { AppNotifyService } from '@app/services/notify/app-notify.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent implements OnInit {
  public isLoggedin: boolean;
  public languages: String[];
  public user;
  public isValidUser: boolean = true;
  public isPreprod: boolean = false;
  public isEmbedMode: boolean = false;
  public isSuperAdminRoute: boolean = window.location.pathname.startsWith('/super-admin');
  constructor(
    public router: Router,
    public _authenticationStateService: AuthenticationStateService,
    public _languageService: LanguageService,
    private _theme: ThemeService,
    private store$: Store,
    private _matDialog: MatDialog,
    private _jwt: JwtService,
    private bnIdle: BnNgIdleService,
    private renderer: Renderer2,
    private _notify: AppNotifyService
  ) {
    this._theme.init();

    if (environment.apiUrl=="https://counting.trakrsuite.com/api") {
      LogRocket.init('rtbhei/trakrcountingomc');

      this.store$.select(selectMeState).pipe(
        skipWhile(res => res == null),
        take(1)
      ).subscribe((me) =>  {

        LogRocket.identify(me.usrID, {
          name: me.usrFirstName + ' ' + me.usrLastName,
          email: me.usrEmail,
          locID: me.locID,
          fTypeID: me.fTypeID,
          tier_id: me.tier_id,
          tier_name: me.tier_name,
          locName: me.locName
        });

      });
    }
    
    if (environment.apiUrl!="https://counting.trakrsuite.com/api") {
      this.isPreprod = true;
      this.renderer.addClass(document.body, 'has-demo-banner');
    }

   

    // Handle impersonate login from super admin panel
    this.handleImpersonate();

    //this.store$.dispatch(CoreActions.loadMe());
    this.checkIfInIframe();
  }


  ngOnInit() {

    // The DYMO print helpers (assets/scripts/printerCode.js) are plain scripts
    // outside Angular, so they cannot read `environment`. They need the API
    // base to fetch a label's QR as a PNG; publishing it here keeps them
    // working when the app and the API are not on the same origin (local dev).
    try {
      localStorage.setItem('apiUrl', environment.apiUrl);
    } catch (e) { }

    /* Those same scripts have no injector, so they cannot open a dialog. This
       gives them one: they call window.trakrNotify and the message arrives as
       a dialog or a toast instead of a browser alert. */
    this._notify.register();

    this.bnIdle.startWatching(1800).subscribe(res => {
      // Skip session timeout dialog in embed mode (iframe) - no session to expire
      if (res && this.router.url!='/login' && !this.isEmbedMode && !this.router.url.startsWith('/super-admin') && !this.router.url.startsWith('/lookup')) {
        const dialogRef = this._matDialog.open(SessionExpiredComponent, {
          width: '500px',
          disableClose: true,
        });

        dialogRef.afterClosed().subscribe(result => {
          //console.log('Modal closed', result);
        });

        this.bnIdle.stopTimer();
      }
    });

    this._authenticationStateService.userAuthState.subscribe(res => {
      if (!res && !this.isSuperAdminRoute) {
        const p = location.pathname;
        if (p !== '/login' && p !== '/update-password' && p !== '/reset-password' && p !== '/forgot-login' && !p.startsWith('/authorized/') && !p.startsWith('/super-admin') && !p.startsWith('/lookup')) {
          this.router.navigateByUrl("/login");
        }
      }
      this.isLoggedin = res;
    });

    this._languageService.init();
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      this.isSuperAdminRoute = (evt as NavigationEnd).url.startsWith('/super-admin');
      window.scrollTo(0, 0)
    });
  }

  private handleImpersonate(): void {
    const params = new URLSearchParams(window.location.search);
    if (params.get('impersonate') !== '1') return;

    const token = localStorage.getItem('impersonate_token');
    if (!token) return;

    const username = localStorage.getItem('impersonate_username');
    const locID = localStorage.getItem('impersonate_locID');
    const fTypeID = localStorage.getItem('impersonate_fTypeID');

    // Move to normal auth keys
    localStorage.setItem('token', token);
    if (username) localStorage.setItem('username', username);
    if (locID) {
      localStorage.setItem('locationsUser', locID);
      localStorage.setItem('location', locID);
    }
    if (fTypeID) localStorage.setItem('franchise', fTypeID);

    // Clean up impersonate keys
    localStorage.removeItem('impersonate_token');
    localStorage.removeItem('impersonate_username');
    localStorage.removeItem('impersonate_locID');
    localStorage.removeItem('impersonate_fTypeID');

    // Hard reload clean URL
    window.location.href = '/';
  }

  private checkIfInIframe(): void {
    if (window !== window.top) {
      // Allow iframe embedding from trakrsuite.com
      const allowedOrigins = ['https://www.trakrsuite.com', 'https://trakrsuite.com'];
      const referrer = document.referrer;
      const isAllowed = allowedOrigins.some(origin => referrer.startsWith(origin));

      if (!isAllowed) {
        throw new Error('Iframe detected!');
      }

      // Hide demo banner in embed mode
      this.isEmbedMode = true;
      this.renderer.removeClass(document.body, 'has-demo-banner');
    }
  }

}